<template>
  <section>
    <div class="content_bg">
      <div class="content">
        <br /><br />
        <Caption label="오시는 길" />
        <br />

        
        <img class="title_box pc" src="@/assets/images/map.png" />

        <img class="title_box mobile" src="@/assets/images/map_mobile.png" />
        <br/>

        <div class="para">
          <div class="line">
            <div>
              <img class="icon" src="@/assets/images/icon_location.png" />
            </div>
            <div class="text">
              경기도 성남시 분당구 판교역로192번길 16 8층 86호 에이552
            </div>
          </div>

          <div class="line">
            <div>
              <img class="icon" src="@/assets/images/icon_mail.png" />
            </div>
            <div class="text">mondayless.inc@gmail.com</div>
          </div>

          <div class="line">
            <div>
              <img class="icon" src="@/assets/images/icon_phone.png" />
            </div>
            <div class="text">(한국) 010-5274-6736</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
  
  <script>
import Caption from "./Caption.vue";
export default {
  components: {
    Caption,
  },
  data() {
    return {};
  },
};
</script>
  
<style scoped>
.content_bg {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: fit-content;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
}

.content {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: 100%;
  max-width: 1140px;
  padding-top: 30px;
  padding-bottom: 30px;
  z-index: 1;
  /* background-color: #f00; */
}

.title_box {
  width: 640px;
}

.para {
  width: 640px;
  margin-top: 30px;
  margin-bottom: 30px;
  display: inline-block;
}

.line {
  display: flex;
  align-items: center;
}
.line img {
  width: 24px;
  display: inline-block;
}

.text {
  margin-left: 10px;
  font-size: 14px;
  color: #000000;
  width: 100%;
  text-align: left;
  display: inline-block;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: fit-content;
    background-color: #ffffff;
    position: relative;
    overflow: hidden;
  }

  .content {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: 100%;
    max-width: 1140px;
    padding-top: 30px;
    padding-bottom: 30px;
    z-index: 1;
    /* background-color: #f00; */
  }

  .para {
    width: 288px;
    margin-top: 30px;
    margin-bottom: 30px;
    display: inline-block;
  }


  .title_box {
    width: 288px;
  }

  .line {
    display: flex;
    align-items: center;
  }
  .line img {
    width: 24px;
    display: inline-block;
  }

  .text {
    margin-left: 10px;
    font-size: 14px;
    color: #000000;
    width: 100%;
    text-align: left;
    display: inline-block;
  }
  
}
</style>
  